import React from 'react';

import { RuntimeLoader } from '@rive-app/canvas';
import riveWasmUrl from '@rive-app/canvas/rive.wasm?url';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRoot } from 'react-dom/client';

import './utils/logger';
import './index.css';
import { App } from './App/App';
import { DynamicBrowserRouter } from './App/DynamicBrowserRouter';
import { IwQueryClientProvider } from './store/IwQueryClientProvider';

// Self-host the Rive WASM runtime instead of letting Rive default-load it
// from unpkg.com. Avoids a public-CDN runtime dependency and the associated
// supply-chain / CSP-allowlist risk.
RuntimeLoader.setWasmUrl(riveWasmUrl);

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <IwQueryClientProvider>
      <ReactQueryDevtools initialIsOpen={false} />
      <DynamicBrowserRouter>
        <App />
      </DynamicBrowserRouter>
    </IwQueryClientProvider>
  </React.StrictMode>,
);
